<template>
    <section class="page-contact m-t-16 m-t-small-0">
        <container size="lg" class="px-small-0 px-medium-0 px-large-0 px-100 rounded-sm-0">
            <center>
                <div class="page-contact-body">
                    <div class="p-x-small-28 m-b-small-32">
                        <Row>
                            <template v-for="(shortcut, i) in shortcuts.filter(e => e.default.includes(contactType))">
                                <div :key="i" class="col-md-6">
                                    <ContactUsShortcut :shortcut="shortcut" />
                                </div>
                            </template>
                        </Row>
                    </div>

                    <template v-if="isContact">
                        <div class="form-container m-b-48 m-b-small-0">
                            <div class="form-container-cover p-x-64 p-y-64 p-x-small-28" :style="{ backgroundImage: `url(${$image(bgImage)})` }">
                                <Heading color="on-color" class="f-w-700 m-b-8" tag="p" size="web-xx-lg">
                                    {{ headingText }}
                                </Heading>

                                <Texture size="lg" color="on-color" class="f-w-700">
                                    {{ subTitle }}
                                </Texture>
                            </div>
                            <div class="p-x-36 p-y-36 p-x-small-28">
                                <div class="form-contact-us text-left">
                                    <form class="row" @submit.prevent="submit">
                                        <div class="form-group m-0 col-md-12">
                                            <InputText class="p-b-16" label="Name *" v-validate="'required'" v-model="form.name" :assistive="errors.first('name')" :error="errors.has('name')" name="name" />
                                        </div>

                                        <div class="form-group m-0 col-md-12">
                                            <InputText classes="p-b-16" label="Email *" v-validate="'required|email'" v-model="form.email" :assistive="errors.first('email')" :error="errors.has('email')" name="email" />
                                        </div>
                                        <div class="form-group m-0 col-md-12">
                                            <InputText class="p-b-16" :class="{ required: job }" label="Phone Number" v-validate="{ required: job }" v-model="form.phone" :assistive="errors.first('phone')" :error="errors.has('phone')" name="phone" />
                                        </div>
                                        <div class="form-group m-0 col-md-12" v-if="!ticket">
                                            <InputText class="p-b-16" :class="{ required: job }" label="Company Name" v-validate="{ required: job }" v-model="form.company" :assistive="errors.first('company')" :error="errors.has('company')" name="company" />
                                        </div>
                                        <div class="form-group col-md-12" v-if="job">
                                            <InputText class="p-b-16" :class="{ required: job }" label="Job Title" v-validate="{ required: job }" v-model="form.jobTitle" :assistive="errors.first('job')" :error="errors.has('job')" name="job" />
                                        </div>
                                        <div class="form-group m-0 col-md-12">
                                            <InputTextarea classes="p-b-16" textarea-styles="height: 124px !important" body-styles="height: 124px !important" label="Your message *" v-validate="'required'" v-model="form.message" :assistive="errors.first('message')" :error="errors.has('message')" name="message" :max="messageMaxLength" :char-counter="true" />
                                        </div>

                                        <div class="form-group m-0 col-md-12">
                                            <div class="d-flex justify-content-end">
                                                <tuber type="submit" class="btn md primary f-s-16 l-h-24 f-w-700 " :text="btnText" :loading="loading" />
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-if="!isContact">
                        <div>
                            <div class="calendly-inline-widget" data-url="https://calendly.com/d/ckyr-zm8-j8b?primary_color=ff3357" style="height:1000px;" />
                            <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async />
                        </div>
                    </template>
                </div>
            </center>
        </container>
    </section>
</template>

<script>
import get from 'lodash/get';
import Swal from 'sweetalert2';
import lottie from 'lottie-web';
import loadingAnimation from '~/lottie/loading.json';
import {
    breadcrumb,
    webPageSchema,
} from '~/scripts/utils/constants/structured-data/index';
import ContactUsShortcut from '~/components/common/shortcut';

const formDefault = function () {
    return {
        name: '',
        company: '',
        phone: '',
        email: '',
        message: '',
        jobTitle: '',
    };
};

const shortcuts = [{
    uri: '/faq',
    heading: 'Having some trouble with your app?',
    description: 'Get Help',
    default: ['contact', 'demo'],
},
{
    uri: '/contact?talk-to-an-expert=true',
    heading: 'Want to hop on a demo?',
    description: 'Find it here',
    default: ['contact'],
},
{
    uri: '/contact',
    heading: 'Got something to ask?',
    description: 'Ask here',
    default: ['demo'],
},
];

export default {
    components: {
        ContactUsShortcut,
    },
    layout: 'theme',
    data() {
        return {
            form: formDefault(),
            messageMaxLength: 300,
            loading: false,
            shortcuts: [...shortcuts],
        };
    },
    head() {
        return {
            title: 'Contact Us | Peekage: Product Sampling Platform',
            __dangerouslyDisableSanitizers: ['script'],
            script: [{
                innerHTML: JSON.stringify(breadcrumb({
                    name: 'Contact us',
                    uri: this.$route.path,
                })),
                type: 'application/ld+json',
            },
            {
                innerHTML: JSON.stringify(webPageSchema),
                type: 'application/ld+json',
            },
            {
                src: 'https://assets.calendly.com/assets/external/widget.js',
                type: 'text/javascript',
                async: true,
            },
            ],
            meta: [{
                hid: 'description',
                name: 'description',
                content: 'Contact Peekage through a simple form. We\'ll get back to you in no time.',
            }],
            link: [{
                rel: 'canonical',
                href: 'https://peekage.com/contact',
            }],
        };
    },
    computed: {
        messageLength() {
            return this.form.message.length;
        },
        ticket() {
            return this.$route.query.ticket;
        },
        job() {
            return get(this.$route.query, 'talk-to-an-expert', false);
        },
        checkContactType() {
            return Boolean(get(this.$route.query, 'talk-to-an-expert', false));
        },
        isDemo() {
            return this.checkContactType;
        },
        isContact() {
            return !this.checkContactType;
        },
        contactType() {
            if (this.isDemo) return 'demo';
            return 'contact';
        },
        headingText() {
            if (this.isDemo) return 'Looking for a demo?';
            return 'Anything we can assist you with?';
        },
        subTitle() {
            if (this.isDemo) return 'Tell us a little about yourself and one of our experts will get in touch with you shortly.';
            return 'We’d love to hear from you';
        },
        bgImage() {
            if (this.isDemo) return 'contact/brand_inquiry.jpg';
            return 'contact/general_inquiry.jpg';
        },
        btnText() {
            if (this.isDemo) return 'Book a demo';
            return 'Submit';
        },
    },
    mounted() {
        lottie.loadAnimation({
            container: this.$refs.loading,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: loadingAnimation,
        });
    },
    methods: {
        submit() {
            const formUrl = '/v1/contact';

            this.$validator.validate().then(valid => {
                if (valid) {
                    let form = this.form;
                    const {
                        company,
                        phone,
                    } = form;

                    if (!this.job) {
                        form = Object.assign({}, form, {
                            jobTitle: 'No-job',
                        });
                    }

                    if (this.ticket) {
                        form = Object.assign({}, form, {
                            company: 'Ticket',
                        });
                    }

                    if (!company.length) {
                        form = Object.assign({}, form, {
                            company: 'No-Company',
                        });
                    }

                    if (!phone.length) {
                        form = Object.assign({}, form, {
                            phone: 'No-Phone',
                        });
                    }

                    this.loading = true;
                    this.$axios.$post(formUrl, form).then((response) => {
                        this.$gtm.sendGTMEvent({
                            event: 'event',
                            eventCategory: 'Contact Us',
                            eventAction: 'Click',
                            eventLabel: 'Send',
                        });

                        Swal.fire('Success',
                            'Your request has been submitted',
                            'success');

                        this.form = formDefault();
                        this.errors.clear();
                        this.$validator.reset();
                        this.loading = false;
                    }).catch(e => {
                        Swal.fire('Error',
                            'Your request has failed',
                            'danger');
                        this.loading = false;
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.page-contact {

    &-body {
        width: 100%;
        display: flex;
        // flex-direction: row-reverse;
        flex-flow: column-reverse;
    }

    .form-container {
        overflow: hidden;
        box-sizing: border-box;

        &-cover {
            background-repeat: no-repeat;
            background-size: auto;
            text-align: left;
        }
    }

    .lottie-loading {
        display: block;
        width: 32px;
        height: 32px;
    }

    @media only screen and (min-width: 768px) {

        /* For desktop: */
        .form-container {
            display: flex;
            align-items: stretch;
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 12px;

            &-cover {
                background-size: cover;
            }

            &>div {
                width: 50%;
            }
        }

        &-body {
            max-width: 964px;
            display: block;
        }
    }
}
</style>
